<tdv-upload-resource-progress-img
  [base64]="base64"
  [isLoaded]="canOpenResource"
  [isDicom]="isDicom"
  [ngClass]="{ done: canOpenResource }"
  (click)="canOpenResource ? openResource() : null"
></tdv-upload-resource-progress-img>

<tdv-upload-resource-progress-info
  [item]="data"
  [progress]="progressVal"
  [isTypeDetectionProgress]="data.isTypeDetectionProgressWatcher.$ | async"
  class="flex flex-grow"
>
</tdv-upload-resource-progress-info>

<button
  *ngIf="isBlobLoaded || data.errorWatcher.value"
  type="button"
  [ngClass]="{ invisible: data.isProgressWatcher.sgnl() }"
  tabindex="-1"
  class="ml-8 relative top-3"
  (click)="close()"
>
  <tdv-icon-svg-x color="default" class="w-26 h-26"></tdv-icon-svg-x>
</button>
